import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHubIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 11,
		height: 11,
		fill: "url(#pattern0)"
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("pattern", {
		id: "pattern0",
		patternContentUnits: "objectBoundingBox",
		width: 1,
		height: 1,
		children: /* @__PURE__ */ _jsx("use", {
			xlinkHref: "#image0_216_4732",
			transform: "scale(0.03125)"
		})
	}), /* @__PURE__ */ _jsx("image", {
		id: "image0_216_4732",
		width: 32,
		height: 32,
		xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAACp0lEQVRYhcWXXYhNURTHf3Pn3sEIQw1JuUXjK6R8llKTjwchLxpKpJkoDxOlUN7I5OPBx5OS8kAapSmRmiiTkpGmEBIx4mEGzQgx3Tl4WGu7d+6cdT7uufKv3e3s/V//tda+e691DvxnVISsLwRaEmiPA7YDz0vUoB3wEo62sCgtrAWuAz2axS8fzhLgM/DaZy0DXEZ2oR7oCAqkGJXAYySDXQanQkWvBejsV437hP/dQ9Ckhs+QTPywlfw2rzE4I4E3ytkU1fkooFuNNhic6gJhD3gCpA3uNuW8AkZECeCQGtzD3rbDDD9suw1uCnionOYw5xOBfmAQWGZwssA3nwB6gQmGzWrl9CCH0sRZJbYGcK74OHfjdIDdLeUctQjTgB/AT6DO4CxHdscKYACYZ9jOB3LAd2CqH6FVRU4ZAingQYBzN9oNe4CLyrlQvLBUM+sDag3jxgjO3VhnaGSRHcghO/IXt9XwoGE4BvgQI4CX2FfuuHJuuon1OvEOud9+OBHDuRv7DK0a4KNyVgF06UOTYTADOZxxA+gDJhmartZ0poBHOjnbIJ8Eqoy1IIwFjhhrM/X3BcAU4CuS5fQi4kqSteIcsLhIcy7565h1k+5gXCogZpAanyQAD7jL0JLepvPHCqMajxyMQWCRzjWXwbkbDaq5Qp8/4VO2D+jiHV3sLWMA3cBopMF5wF7ntHBrqpH7Oxmpimn834JKQSVSpjcDb4E5+jwMOzXCp9j9vRRUIcl5wJYgYgZ5C/KAHWUMYI9qdiI9JRAbCa+McVBD/jzVRzXqILg3xEGLat2IY+S6Yz92OY0CV+RywIK4xleRyM8kCMD1//MWIehdvQ6phE7od0znaeSDZgCYBbyPaQ9I9kmLkNWQgPCvlVqSX8dzwJeEGv8OfwB4O0GSXLEPhgAAAABJRU5ErkJggg=="
	})] })]
});
export default SvgHubIcon;
